import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'

import { RouteParams } from 'meta/routes'
import { handlePDFDownload } from 'utils/pdf'

import withTranslation from 'components/HOC/WithTranslation'
import { useBackendApiBase } from 'hooks/useEnv'

const ReceiptsPdf: React.FC = () => {
  const { t } = useTranslation()

  const location = useLocation()
  const isReceiptsPath = location.pathname.includes('receipts')

  const { id } = useParams<RouteParams['ReceiptsPdf']>()
  const backendApiBase = useBackendApiBase()

  useEffect(() => {
    if (!backendApiBase || !id) return

    handlePDFDownload(
      `${backendApiBase}/${isReceiptsPath ? 'receipts' : 'credit-notes'}/${id}/pdf`,
      `receipt-${id}.pdf`
    )
  }, [backendApiBase, id])

  return <div>{t('receipt:pdf_download_in_progress')}</div>
}

const namespaces = ['receipt']

export default withTranslation(namespaces)(ReceiptsPdf)
